import { Container } from 'inversify'

export class AltContainer extends Container {}
